import type { PayloadAction } from '@reduxjs/toolkit';

import type { TripEventType, TripHistoryState } from './tripHistorySlice.model';

export const TRIP_HISTORY_REDUCERS = {
  selectTrip: (
    state: TripHistoryState,
    action: PayloadAction<string | null>
  ) => {
    state.selectedTripId = action.payload;
  },
  selectDate: (
    state: TripHistoryState,
    action: PayloadAction<Date | string>
  ) => {
    // Convert Date to ISO string if needed
    const dateValue =
      action.payload instanceof Date
        ? action.payload.toISOString()
        : action.payload;
    state.selectedDate = dateValue;
  },
  hoverTrip: (
    state: TripHistoryState,
    action: PayloadAction<string | null>
  ) => {
    state.hoveredTripId = action.payload;
  },
  selectCluster: (
    state: TripHistoryState,
    action: PayloadAction<number | null>
  ) => {
    state.selectedClusterId = action.payload;
  },
  selectEvent: (
    state: TripHistoryState,
    action: PayloadAction<string | null>
  ) => {
    state.selectedEventId = action.payload;
  },
  hoverEvent: (
    state: TripHistoryState,
    action: PayloadAction<string | null>
  ) => {
    state.hoveredEventId = action.payload;
  },
  setAssetId: (
    state: TripHistoryState,
    action: PayloadAction<string | null>
  ) => {
    state.assetId = action.payload;
  },
  setMapReady: (state: TripHistoryState, action: PayloadAction<boolean>) => {
    state.isMapReady = action.payload;
  },
  setClusterCoordinates: (
    state: TripHistoryState,
    action: PayloadAction<number[] | GeoJSON.Position | null>
  ) => {
    state.clusterCoordinates = action.payload;
  },
  setHoverOnList: (state: TripHistoryState, action: PayloadAction<boolean>) => {
    state.hoverOnList = action.payload;
  },
  setHoverEventType: (
    state: TripHistoryState,
    action: PayloadAction<TripEventType | null>
  ) => {
    state.hoverEventType = action.payload;
  },
};
